import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PanelSkeleton from "../PanelSkeleton";
import { FaToggleOn, FaToggleOff } from "react-icons/fa";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ImSpinner2 } from "react-icons/im";

const FeaturesPanel = () => {
  const [features, setFeatures] = useState([]);
  const [announce, setAnnounce] = useState("");
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [exporting, setExporting] = useState(false);

  const fetchFeatures = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/features/dashboardFetch`, { withCredentials: true });
      setFeatures(res.data.data);
    } catch (err) {
      toast.error(<span className="toast">لم نتمكن من تحميل البيانات. حاول مرة اخرى</span>)
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchFeatures();
  }, []);

  const handleFeatureAct = async (id, active) => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/features/act/${id}`, { active }, { withCredentials: true });
      await fetchFeatures();
    } catch (error) {
      console.error("error activating feature");
    }
  }

  const reset = () => {
    setEdit(false); 
    setAnnounce("");
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    confirmAlert({
      message: `تحديث التنبيه ؟`,
      buttons: [
        {
          label: 'نعم',
          onClick: async () => {
            setSubmitting(true);
            try {
              await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/features/announce`, { announce: announce }, { withCredentials: true });
              toast.success(<span className="toast">تم تحديث التنبيه بنجاح</span>);
              reset();
              await fetchFeatures();
            } catch (error) {
              toast.error(<span className="toast">لم نتمكن من تحديث التنبيه. حاول مرة اخرى</span>);
            } finally {
              setSubmitting(false);
            }
          }
        },
        {
          label: 'لا'
        }
      ]
    })
  };

  const exportEmails = async () => {
    confirmAlert({
      message: `تحميل جميع ايميلات العملاء ؟`,
      buttons: [
        {
          label: 'نعم',
          onClick: async () => {
            setExporting(true);
            try {
              const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/features/exportEmails`, {}, {
                withCredentials: true
              });
        
              if (response.data.data.success) {
                // Download each CSV file
                response.data.data.batches.forEach(batch => {
                  // Create download link for each file
                  const blob = new Blob([batch.content], { type: 'text/csv;charset=utf-8;' });
                  const url = URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', batch.fileName);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  URL.revokeObjectURL(url);
                  
                  // Small delay between downloads to avoid browser issues
                  setTimeout(() => {}, 500);
                });
              }
            } catch (error) {
              toast.error(<span className="toast">حدث خطأ اثناء تحميل ايميلات العملاء. حاول مرة اخرى</span>);
            } finally {
              setExporting(false);
            }
          }
        },
        {
          label: 'لا'
        }
      ]
    })
  };

  if (loading) {
    return <PanelSkeleton count={2} />
  };

  return (
    <div className="panelcont">
    <div className="paneldet deliverypanel">
      {features.map(f => (
        <div key={f.id}>
          <div className="space">
            <p>{f.name === 'announce' ? 'إظهار شريط التنبيه' : 'إظهار نافذة التسجيل'}</p>
  
            <button onClick={() => handleFeatureAct(f.id, f.active)}>
              {f.active === 0 ? <FaToggleOff className="off" /> :
                <FaToggleOn className="on" />
              }
            </button>
          </div>

          {(f.name === 'announce' && !edit) &&
            <div className="announcecont">
              <span>{f.announce}</span>

              <button 
                onClick={() => {
                  setEdit(true);
                  setAnnounce(features.find(f => f.name === 'announce').announce);
                }} 
                disabled={submitting}
                className="edit"
                style={{margin: "0"}}
              >
               تعديل
              </button>
            </div>
          }

          {(f.name === 'announce' && edit) && 
            <>
              <textarea
                value={announce}
                onChange={(e) => setAnnounce(e.target.value)}
                maxLength={70}
              ></textarea>

              <div className="space yesno">
                <button 
                  onClick={handleSubmit} 
                  disabled={submitting}
                  className="buttonBorder" 
                >
                  {submitting ? <ImSpinner2 className="smallspinner" /> : "تحديث"}
                </button>
    
                <button 
                  onClick={reset}
                  className="buttonBorder"
                  style={{color: "rgb(253, 61, 61)"}}
                >رجوع</button>
              </div>
            </>
          }
        </div>
      ))}

      <div className="space">
        <p>تحميل جميع ايميلات العملاء</p>
        <button onClick={exportEmails} disabled={exporting} className="good buttonBorder">
          {exporting ? <ImSpinner2 className="smallspinner" /> :
          "تحميل"
          }
        </button>
      </div>
    </div>
    </div>
  )
}

export default FeaturesPanel;
